import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getHotels = async (token) => {
  console.log(token);
  const response = await axios.get(`${base_url}LaxuryHotel/AllLaxuryHotel`, {

    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
    }
  });

  return response.data;

};
const createHotel = async (values) => {
  const token = values.get("token")
  console.log(token);
  const response = await axios.post(
    `${base_url}LaxuryHotel/addLaxuryHotel`,
    values,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );

  return response.data;
};
const updateHotel = async (values) => {
  const token = values.get("token");
  const id = values.get("id");
  
  const response = await axios.put(
    `${base_url}LaxuryHotel/editLaxuryHotel/${id}`,
    values,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );

  return response.data;
};

const getHotel = async (id) => {
  const response = await axios.get(`${base_url}LaxuryHotel/getById/${id}`);

  return response.data;
};

const deleteHotel = async (id) => {
  const response = await axios.delete(`${base_url}LaxuryHotel/deleteLaxuryHotel/${id}`);

  return response.data;
};
const HotelService = {
  getHotels,
  createHotel,
  getHotel,
  updateHotel,
  deleteHotel,
};

export default HotelService;
